/**
 * A compact loot row used in the dead-screen loot summary.
 * Displays icon, name, and rarity — no stats or interactivity.
 *
 * Props:
 *   item  — item object
 *   color — resolved rarity color string
 */
export function LootItemRow({ item, color }) {
  return (
    <div className="loot-item" style={{ '--rarity-color': color }}>
      <span className="loot-item-icon">{item.icon}</span>
      <div className="loot-item-info">
        <span className="loot-item-name">{item.name}</span>
        <span className="loot-item-rarity" style={{ color }}>{item.rarity}</span>
      </div>
    </div>
  );
}
